import { connectStateResults } from 'react-instantsearch-dom';

const CustomResults = connectStateResults(
  ({ searchState, searchResults, children }) => {
    if (searchState && !searchState.query)
      return <p className="search-status">No recent searches</p>;
    if (searchResults && searchResults.nbHits !== 0) {
      return children;
    } else {
      return (
        <p className="search-status">
          No results for <span>{searchState.query}</span>.
        </p>
      );
    }
  }
);

export default CustomResults;
